module.exports = __webpack_public_path__ + "static/media/16.50ab472b.JPG";